import React from 'react';
import { Navigate } from 'react-router-dom';
 
const RouteGuard = ({ children, currentRoleId, allowedRoleIds = [] }) => {
  if (!allowedRoleIds.includes(currentRoleId)) {
    return <Navigate to="/no-access" replace />;
  }
 
  return children;
};
 
export default RouteGuard;